import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "text-white p-8",
    style: { "background": "rgb(27, 28, 30)" }
};
const _hoisted_2 = { class: "container mx-auto text-center" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'Footer',
    props: {
        projectName: {},
        currentYear: {}
    },
    setup(__props) {
        const openCookieSettings = () => {
            if (typeof window === 'undefined')
                return;
            window.dispatchEvent(new CustomEvent('open-cookie-settings'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("p", null, "© " + _toDisplayString(_ctx.currentYear) + " " + _toDisplayString(_ctx.projectName) + ". All rights reserved.", 1 /* TEXT */),
                    _createElementVNode("nav", { class: "mt-3" }, [
                        _cache[0] || (_cache[0] = _createElementVNode("a", {
                            class: "text-gray-300 hover:text-white mx-2",
                            href: "/impressum"
                        }, "Impressum", -1 /* CACHED */)),
                        _cache[1] || (_cache[1] = _createElementVNode("a", {
                            class: "text-gray-300 hover:text-white mx-2",
                            href: "/impressum?tab=datenschutz"
                        }, "Datenschutz", -1 /* CACHED */)),
                        _createElementVNode("button", {
                            class: "text-gray-300 hover:text-white mx-2",
                            type: "button",
                            onClick: openCookieSettings
                        }, "Cookies")
                    ])
                ])
            ]));
        };
    }
});
